import { Paragraph } from "@digdir/designsystemet-react";
import "./NavItem.css";

export const NavItemTopLevel: React.FC<{
    heading: string;
}> = ({ heading }) => {
    return (
        <div className="nav-item nav-item--top">
            <Paragraph data-size="sm">
                <span style={{ fontWeight: "700", display: "block" }}>{heading}</span>
            </Paragraph>
        </div>
    );
};
